import {Component, inject, ChangeDetectionStrategy} from "@angular/core"
import {RouterOutlet} from "@angular/router"
import {CheckboxesFilterComponent, TagSearchFilterComponent} from "@common/components/filters"
import {ItemFiltersComponent} from "@common/components/item"
import {Labels} from "@labels"
import {SidebarLayoutComponent} from "@platform/components/layouts/sidebar-layout/sidebar-layout.component"
import {UsersGridComponent} from "@platform/components/users/users-grid/users-grid.component"
import {CreateItemComponent} from "@common/components/base/create-item.component"
import {AddUserDialogComponent} from "@platform/components/dialogs/add-user-dialog/add-user-dialog.component"
import {OrganizationsService} from "@common/services/organizations/organizations.service"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-users-page",
    imports: [CheckboxesFilterComponent, ItemFiltersComponent, RouterOutlet, SidebarLayoutComponent, TagSearchFilterComponent, UsersGridComponent],
    templateUrl: "./users-page.component.html",
    styleUrl: "./users-page.component.scss",
})
export class UsersPageComponent extends CreateItemComponent<AddUserDialogComponent> {
    readonly Labels = Labels
    readonly organizations = inject(OrganizationsService)

    protected openCreateDialog() {
        const dialogRef = this.dialog.open(AddUserDialogComponent, {
            data: {},
        })

        // Set the organization ID in the dialog
        const currentOrgId = this.organizations.$current()?.id
        if (currentOrgId && dialogRef.componentInstance) {
            dialogRef.componentInstance.$organizationId.set(currentOrgId)
        }

        this.setDialogRef(dialogRef)
    }

    protected override handleDialogResult(result: unknown): boolean | void {
        if (result && typeof result === "object" && "id" in result) {
            const typedResult = result as {id: string}
            if (typedResult.id) {
                // Navigate to the created user
                void this.router.navigate([typedResult.id], {
                    relativeTo: this.route,
                    queryParamsHandling: "preserve",
                })
                // Return false to skip default navigation
                return false
            }
        }

        // Return undefined/void for default behavior
    }
}
